import type {
    PersistedUserEvent,
    PersistedUserEventRecord,
} from '@fruitful/types';

import { buildQueryParams, requestBuilder } from '../../http/RequestBuilder';

const useGetUserEvents = requestBuilder.query<
    PersistedUserEventRecord[],
    { eventType: PersistedUserEvent }
>({
    endpoint: ({ eventType }) =>
        `/api/user/events${buildQueryParams({ eventType })}`,
    queryKey: ({ eventType }) => ['userEvents', eventType],
});

export default useGetUserEvents;
